import { Star } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";

export default function Testimonials({ limit = 5 }) {
  const items = TESTIMONIALS.slice(0, limit);
  return (
    <div data-testid="testimonials-grid" className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      {items.map((t, i) => (
        <figure
          key={i}
          data-testid={`testimonial-${i}`}
          className="card-brutal flex h-full flex-col p-6 md:p-8"
        >
          <div className="flex items-center gap-1 text-[#FFD700]">
            {Array.from({ length: t.rating }).map((_, j) => (
              <Star key={j} size={16} fill="#FFD700" strokeWidth={0} />
            ))}
          </div>
          <blockquote className="mt-4 flex-1 text-base leading-relaxed text-black md:text-lg">
            "{t.quote}"
          </blockquote>
          <figcaption className="mt-6 border-t border-black/10 pt-4">
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center border-2 border-black bg-[#FFD700] font-black text-black">
                {t.name[0]}
              </div>
              <div>
                <div className="display text-sm font-black">{t.name}</div>
                <div className="text-xs font-medium text-black/60">{t.role}, {t.company}</div>
              </div>
            </div>
          </figcaption>
        </figure>
      ))}
    </div>
  );
}
